<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">抽卡記錄</h1>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <el-input
              v-model="listQuery.cardNameLike"
              placeholder="卡名稱"
              prefix-icon="el-icon-search"
          ></el-input>

          <div>
            <el-select v-model="listQuery.titleId" clearable placeholder="全部主題">
              <el-option
                  v-for="item in cardTitle"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>

          <div>
            <el-select v-model="listQuery.propertyId" clearable placeholder="全部屬性">
              <el-option
                  v-for="item in cardProperty"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>

          <el-input
              v-model="listQuery.userNoLike"
              placeholder="學生賬號"
              prefix-icon="el-icon-search"
          ></el-input>
          <el-input
              v-model="listQuery.nameLike"
              placeholder="學生姓名"
              prefix-icon="el-icon-search"
          ></el-input>
          <div class="search-buttons">
            <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 + 手机卡片 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width:100%"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無數據' : ''"
          >
            <el-table-column label="#" type="index" width="50" align="center"></el-table-column>

            <!-- 点击图片弹出弹窗 -->
            <el-table-column label="圖片" align="center" min-width="120">
              <template slot-scope="{ row }">
                <el-image
                    v-if="row.image || row.imageUrl"
                    :src="row.image || row.imageUrl"
                    fit="cover"
                    style="width:40px;height:40px;border-radius:4px;cursor:pointer !important;z-index:999"
                    @click.native="openImageDialog(row)"
                ></el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column prop="cardName" label="卡名稱" align="center" sortable="custom" min-width="120"></el-table-column>

            <el-table-column label="主題" align="center" min-width="100">
              <template slot-scope="{ row }">
                {{ getTitleName(row.titleId) }}
              </template>
            </el-table-column>

            <el-table-column label="屬性" align="center" min-width="100">
              <template slot-scope="{ row }">
                {{ getPropertyName(row.propertyId) }}
              </template>
            </el-table-column>

            <el-table-column prop="content" label="介紹" align="center" min-width="180"></el-table-column>
            <el-table-column prop="probability" label="概率" align="center" min-width="100">
              <template slot-scope="{ row }">
                {{ row.probability }}%
              </template>
            </el-table-column>
            <el-table-column prop="userName" label="中獎學生姓名" align="center" sortable="custom" min-width="120"></el-table-column>
            <el-table-column prop="userNo" label="中獎學生賬號" align="center" sortable="custom" min-width="120"></el-table-column>
            <el-table-column prop="studentCode" label="中獎學生編號" align="center" sortable="custom" min-width="120"></el-table-column>
            <el-table-column prop="createdAt" label="獲取時間" align="center" sortable="custom" min-width="120">
              <template slot-scope="{ row }">
                {{ formatDateTime(row.createdAt?.date || row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery._page"
          :limit.sync="listQuery._limit"
          @pagination="getCardsUser"
      />
    </div>

    <!-- 完全透明背景弹窗 -->
    <el-dialog
        :visible.sync="imageDialogVisible"
        width="520px"
        :show-footer="false"
        :show-header="false"
        close-on-click-modal
        custom-class="pure-no-border-dialog"
        append-to-body
    >

      <div class="image-preview-dialog">
        <!-- 大图 -->
        <div class="preview-image">
          <img :src="previewData.image" alt="卡片大图" />
        </div>

        <!-- 详情信息 -->
        <div class="preview-info">
          <h2 class="card-name">{{ previewData.cardName }}</h2>
          <p><span>主題：</span>{{ previewData.titleName }}</p>
          <p><span>屬性：</span>{{ previewData.propertyName }}</p>
          <p><span>介紹：</span>{{ previewData.content || '暂无介绍' }}</p>
          <p><span>概率：</span>{{ previewData.probability }}%</p>
          <p><span>中獎學生：</span>{{ previewData.userName }}（{{ previewData.userNo }}）</p>
          <p><span>獲取時間：</span>{{ previewData.createdAt }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getCardProperty, getCardTitle, editCard, getCardsUser } from "@/api/setting";
import { formatDateTime } from "@/filters";

export default {
  components: { Pagination },
  data() {
    return {
      total: 0,
      staffId: null,
      centerDialogVisible: false,
      addDialogVisible: false,
      editDialogVisible: false,
      currentId: null,
      // 图片弹窗变量
      imageDialogVisible: false,
      previewData: {},
      listQuery: {
        titleId: null,
        propertyId: null,
        nameLike: null,
        userNoLike: null,
        cardNameLike: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      form: {
        name: '',
        titleId: null,
        propertyId: null,
        content: '',
        probability: '',
        imageUrl: '',
      },
      editForm: {
        name: '',
        titleId: null,
        propertyId: null,
        content: '',
        probability: '',
        image: '',
      },
      rules: {
        name: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        titleId: [{ required: true, message: '請選擇主題', trigger: 'change' }],
        propertyId: [{ required: true, message: '請選擇屬性', trigger: 'change' }],
        probability: [
          { required: true, message: '請輸入概率', trigger: 'blur' }
        ]
      },
      tableData: [],
      cardTitle: [],
      cardProperty: [],
    };
  },
  created() {
    this.getCardTitle();
    this.getCardProperty();
    this.getCardsUser();
  },
  methods: {
    formatDateTime(cellValue) {
      if (!cellValue) return '';
      return formatDateTime(new Date(cellValue), 'dd/MM/yyyy HH:mm:ss');
    },
    // 根据ID获取主题名称
    getTitleName(titleId) {
      const item = this.cardTitle.find(t => t.id === titleId);
      return item ? item.name : '-';
    },
    // 根据ID获取属性名称
    getPropertyName(propertyId) {
      const item = this.cardProperty.find(p => p.id === propertyId);
      return item ? item.name : '-';
    },

    // 打开图片预览弹窗
    openImageDialog(row) {
      this.previewData = {
        image: row.image || row.imageUrl || '',
        cardName: row.cardName || row.card_name || '',
        titleName: this.getTitleName(row.titleId),
        propertyName: this.getPropertyName(row.propertyId),
        content: row.content || '',
        probability: row.probability || 0,
        userName: row.userName || row.user_name || '',
        userNo: row.userNo || row.user_no || '',
        createdAt: this.formatDateTime(row.createdAt?.date || row.createdAt)
      };
      this.imageDialogVisible = true;
    },

    // 编辑
    onEditButton(row) {
      this.currentId = row.id;
      this.editForm = {
        name: row.name || '',
        titleId: row.titleId ?? null,
        propertyId: row.propertyId ?? null,
        content: row.content || '',
        probability: Number(row.probability) || 0,
        image: row.image || row.imageUrl || '',
      };
      this.editDialogVisible = true;
    },
    closeEditDialog() {
      this.editDialogVisible = false;
      this.currentId = null;
    },
    submitEditForm() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        editCard(this.currentId, this.editForm).then(() => {
          this.$message.success('修改成功');
          this.closeEditDialog();
          this.getCardsUser();
        }).catch(() => {
          this.$message.error('修改失敗');
        });
      });
    },

    // 基础功能
    handleSortChange(col) {
      this.listQuery.orderBy = col.order ? `${col.prop} ${col.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getCardsUser();
    },
    onSearch() {
      this.listQuery._page = 1;
      this.getCardsUser();
    },
    onReset() {
      Object.keys(this.listQuery).forEach(k => {
        this.listQuery[k] = null;
        if (k === "_page") this.listQuery[k] = 1;
        if (k === "_limit") this.listQuery[k] = 10;
      });
      this.getCardsUser();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
      // 删除逻辑
    },
    onDeleteButton(id) {
      this.staffId = id;
      this.centerDialogVisible = true;
    },
    getCardsUser() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      Object.keys(params).forEach(key => {
        if (params[key] == null) delete params[key];
      });
      getCardsUser(params).then(v => {
        this.tableData = v.data || [];
        this.total = +v.headers["x-total-count"] || 0;
      });
    },
    getCardTitle() {
      getCardTitle().then(v => {
        this.cardTitle = v.data || [];
      });
    },
    getCardProperty() {
      getCardProperty().then(v => {
        this.cardProperty = v.data || [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #B62D2E;
    margin: 0;
  }
}

.layout {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input, .el-select {
      flex: 1;
      min-width: 160px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

.table-container {
  width: 100%;
}

.pagination-wrap {
  text-align: center;
  padding: 10px 0;
}

.dialog-footer {
  text-align: right;
}

/* 完全透明背景弹窗样式 */
::v-deep .pure-no-border-dialog {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  z-index: 9999 !important;
  margin-top: 10px !important;
  .el-dialog__body {
    padding: 0 !important;
    background: transparent !important;
  }
}

/* 自定义关闭按钮 */
.dialog-close-btn {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10000;
  transition: all 0.2s;

  &:hover {
    background: #f5f7fa;
    transform: scale(1.1);
  }

  i {
    font-size: 16px;
    color: #666;
  }
}

.image-preview-dialog {
  text-align: center;
  padding: 20px;
  background: transparent;

  .preview-image {
    margin-bottom: 16px;

    img {
      max-width: 80%;
      border-radius: 8px;
      object-fit: contain;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  .preview-info {
    text-align: left;
    color: #ffffff;
    .card-name {
      font-size: 18px;
      color: #ffffff;
      margin-bottom: 12px;
      text-align: center;
    }

    p {
      margin: 6px 0;
      font-size: 14px;

      span {
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}

@media (max-width: 768px) {
  .page { padding: 8px; }
  .layout { padding: 12px; }
  .search-row { flex-direction: column; align-items: stretch; }
  .pc-table { display: none; }

  /* 移动端弹窗适配 */
  ::v-deep .pure-no-border-dialog {
    width: 90% !important;
  }

  .dialog-close-btn {
    top: 10px;
    right: 10px;
  }
}
</style>